import { useRef } from "react";

import styled from "styled-components/macro";

import extendedFieldHooks from "ExtendedFields/selectorHooks";

import AddFieldSelect from "./AddFieldSelect/AddFieldSelect";
import ExtendedFieldNav from "./ExtendedFieldNav/ExtendedFieldNav";
import FieldEditor from "./FieldEditor/FieldEditor";
import FieldEditorOverlay from "./FieldEditorOverlay";

const Padding = styled("div")`
  padding: 16px;
`;

const ModalPadding = styled("div")`
  padding: 20px;
`;

const SDiv = styled("div")`
  overflow-y: auto;
  width: 100%;
`;

const ThinUI = () => {
  const [isNavigating] = extendedFieldHooks.useIsNavigating();
  const [isEditing] = extendedFieldHooks.useIsEditing();
  const [editWithModal] = extendedFieldHooks.useEditWithModal();
  const screensContainerRef = useRef();

  let showExtendedFieldNav = false;
  let showFieldEditor = false;
  let showAddFieldSelect = false;

  if (isNavigating || editWithModal) showExtendedFieldNav = true;
  else if (isEditing) showFieldEditor = true;
  else if (!isEditing) showAddFieldSelect = true;
  else showExtendedFieldNav = true; // This should never happen, but just in case...

  return (
    <>
      <SDiv
        ref={screensContainerRef}
        data-cy="ExtendedFields_ThinUI"
        $isNavigating={isNavigating}
      >
        {showExtendedFieldNav && (
          <div>
            <ExtendedFieldNav />
          </div>
        )}
        {showAddFieldSelect && (
          <div>
            <Padding>
              <AddFieldSelect />
            </Padding>
          </div>
        )}
        {showFieldEditor && (
          <div>
            <Padding>
              <FieldEditor />
            </Padding>
          </div>
        )}
      </SDiv>
      {editWithModal && <ModalUI />}
    </>
  );
};

const ModalContents = ({ isEditing }) => {
  if (isEditing) return <FieldEditor />;
  else return <AddFieldSelect />;
};

const ModalUI = () => {
  const [isNavigating, setIsNavigating] = extendedFieldHooks.useIsNavigating();
  const [isEditing] = extendedFieldHooks.useIsEditing();

  const close = () => {
    setIsNavigating(true);
  };

  return (
    <FieldEditorOverlay
      isEditing={isEditing}
      close={close}
      show={!isNavigating}
    >
      <ModalPadding data-cy="ExtendedFields_EditWithModal_Padding">
        <ModalContents isEditing={isEditing} />
      </ModalPadding>
    </FieldEditorOverlay>
  );
};

export default ThinUI;
